"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
require("./Listbox.css");
var Button_1 = require("../button/Button");
var Link_1 = require("../link/Link");
var string_1 = require("../../utils/string");
var Dropdown_1 = require("../dropdown/Dropdown");
var Icon_1 = require("../icon/Icon");
var keyboard_1 = require("../../utils/dom/keyboard");
var scroll_1 = require("../../utils/dom/scroll");
var ListboxTheme;
(function (ListboxTheme) {
    ListboxTheme["basic"] = "basic";
    ListboxTheme["box"] = "box";
    ListboxTheme["compact"] = "compact";
})(ListboxTheme = exports.ListboxTheme || (exports.ListboxTheme = {}));
exports.Listbox = function (props) {
    var htmlProps = (function (_a) {
        var options = _a.options, index = _a.index, startIndex = _a.startIndex, scroll = _a.scroll, wrap = _a.wrap, disabled = _a.disabled, theme = _a.theme, onChange = _a.onChange, rest = __rest(_a, ["options", "index", "startIndex", "scroll", "wrap", "disabled", "theme", "onChange"]);
        return rest;
    })(props);
    var dropdownProps = Dropdown_1.useDropdownContext();
    //--- refs ---//
    var el = react_1.useRef(null);
    var optionsRef = react_1.useRef([]);
    var activedescendantId = react_1.useRef(props['aria-activedescendant'] || string_1.getRandomString());
    //--- states ---//
    var _a = __read(react_1.useState(props.startIndex), 2), curIndex = _a[0], setCurIndex = _a[1];
    var _b = __read(react_1.useState(-1), 2), focusedIndex = _b[0], setFocusedIndex = _b[1];
    //--- effects ---//
    react_1.useEffect(function () {
        dropdownProps.setAriaLabel('Listbox dropdown');
    }, []);
    react_1.useEffect(function () {
        optionsRef.current = props.options.map(function (option) { return React.createRef(); });
    }, [props.options]);
    react_1.useEffect(function () {
        if (dropdownProps.expanded && el.current) {
            setTimeout(function () { var _a; return (_a = el.current) === null || _a === void 0 ? void 0 : _a.focus(); });
            if (curIndex > -1) {
                scroll_1.scrollToItemStart(el.current, optionsRef.current[curIndex].current);
            }
            else {
                el.current.scrollTop = 0;
                el.current.scrollLeft = 0;
            }
        }
    }, [dropdownProps.expanded]);
    react_1.useEffect(function () {
        if (props.index !== undefined)
            setCurIndex(props.index);
    }, [props.index]);
    //--- handlers ---//
    var onOptionClick = function (option, index, e) {
        if (props.index === undefined)
            setCurIndex(index);
        dropdownProps.closeDropdown();
        if (props.onChange)
            props.onChange(option, index, e);
    };
    var onKeyUp = function (e) {
        var _a;
        if (document.activeElement === el.current) {
            if (keyboard_1.isKeyReturn(e) || keyboard_1.isKeySpacebar(e)) {
                if ((_a = props.options[focusedIndex]) === null || _a === void 0 ? void 0 : _a.disabled)
                    return;
                setCurIndex(focusedIndex);
                dropdownProps.closeDropdown();
                if (props.onChange) {
                    props.onChange(props.options[focusedIndex], focusedIndex, e);
                }
            }
            //up arrow
            else if (keyboard_1.isKeyArrowUp(e)) {
                if (focusedIndex > 0) {
                    setFocusedIndex(function (prevState) {
                        scroll_1.scrollToItemWhenOutsideVisibleScroll(el.current, optionsRef.current[prevState - 1].current);
                        return prevState - 1;
                    });
                }
            }
            //down arrow
            else if (keyboard_1.isKeyArrowDown(e)) {
                var length_1 = props.options.length;
                if (focusedIndex < length_1 - 1) {
                    setFocusedIndex(function (prevState) {
                        scroll_1.scrollToItemWhenOutsideVisibleScroll(el.current, optionsRef.current[prevState + 1].current);
                        return prevState + 1;
                    });
                }
            }
        }
    };
    var onFocus = function (e) {
        setFocusedIndex(curIndex > -1 ? curIndex : 0);
    };
    var onBlur = function (e) {
        setFocusedIndex(-1);
    };
    return (React.createElement("div", __assign({}, htmlProps, { ref: el, className: classnames_1.default('Listbox', props.className, "Listbox-" + props.theme, {
            'Listbox-wrap': props.wrap,
            'Listbox-scroll': props.scroll,
        }), role: 'listbox', tabIndex: dropdownProps.isHidden ? -1 : 0, "aria-activedescendant": activedescendantId.current, onKeyUp: onKeyUp, onFocus: onFocus, onBlur: onBlur }), props.options.map(function (option, index) {
        return option.route ? (React.createElement(Link_1.Link, { key: index, ref: optionsRef.current[index], id: focusedIndex === index ? activedescendantId.current : undefined, className: classnames_1.default('Listbox_option', option.className, {
                'Listbox_option-disabled': props.disabled || option.disabled,
                'Listbox_option-active': curIndex === index,
                'Listbox_option-focus': focusedIndex === index,
            }), role: 'option', "aria-selected": curIndex === index, "aria-label": typeof option.label === 'string' && curIndex === index
                ? option.label + " (selected)"
                : undefined, tabIndex: -1, to: option.route, disabled: props.disabled || option.disabled, onClick: function (e) { return onOptionClick(option, index, e); } },
            option.label,
            props.theme === ListboxTheme.box && (React.createElement(Icon_1.Icon, { className: 'Listbox_optionIcon', type: Icon_1.IconType.check })))) : (React.createElement(Button_1.Button, { key: index, ref: optionsRef.current[index], id: focusedIndex === index ? activedescendantId.current : undefined, className: classnames_1.default('Listbox_option', option.className, {
                'Listbox_option-disabled': props.disabled || option.disabled,
                'Listbox_option-active': curIndex === index,
                'Listbox_option-focus': focusedIndex === index,
            }), role: 'option', "aria-selected": curIndex === index, "aria-label": typeof option.label === 'string' && curIndex === index
                ? option.label + " (selected)"
                : undefined, tabIndex: -1, disabled: props.disabled || option.disabled, onClick: function (e) { return onOptionClick(option, index, e); } },
            option.label,
            props.theme === ListboxTheme.box && (React.createElement(Icon_1.Icon, { className: 'Listbox_optionIcon', type: Icon_1.IconType.check }))));
    })));
};
exports.Listbox.defaultProps = {
    startIndex: -1,
    theme: 'box',
};
